module.exports = __webpack_public_path__ + "static/img/img-yanghai03.65a3d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-yanghai03.png
// module id = MgxM
// module chunks = 1